import React, { useMemo } from 'react';
import { Divider, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { parseImageUrl } from '@tuqqi/common';
import { managerTableKeepGlobalData, useNewUITranslation } from '@tuqqi/web';

const styles = (theme) => ({
    container: {
        position: 'relative',
        width: theme.constants.searchInputWidth - 40,
        height: 56,
        marginRight: 12,
        borderRadius: 4,
        boxShadow: 'none',
        backgroundColor: 'transparent',
        '&:last-child': {
            marginRight: 0
        },
        display: 'flex',
        flexDirection: 'row',
    },
    suggest: {
        display: 'none',
        position: 'absolute',
        backgroundColor: 'transparent',
        opacity: 0.23,
        borderRadius: 6,
        width: theme.constants.searchInputWidth - 40 + 10,
        height: 56 + 20 - 1,
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        zIndex: 1
    },
    pic: {
        zIndex: 2,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        width: 80,
        height: 56,
    },
    texts: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    title: {
        minHeight: 20,
        maxWidth: 450,
        fontFamily: 'Rubik',
        fontSize: 15,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.33,
        letterSpacing: 'normal',
        textAlign: 'start',
        color: '#21212d',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'rgba(0,0,0,1)'
        },
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
        marginLeft: 16,
        zIndex: 2
    },
    description: {
        minHeight: 20,
        maxWidth: 450,
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.67,
        letterSpacing: 'normal',
        textAlign: 'start',
        color: '#979aaa',
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: 'nowrap',
        marginLeft: 16,
        zIndex: 2
    },
    icon: {
        display: 'flex',
        alignSelf: 'center',
        cursor: 'pointer',
        zIndex: 2
    },
    iconWrap: {
        display: 'flex',
        position: 'relative',
        marginRight: 0,
        marginLeft: 'auto'
    },
    divider: {
        marginTop: 8,
        marginBottom: 8,
        color: '#dddee6',
        '&:last-child': {
            marginTop: 0,
            display: 'none',
            marginBottom: 0
        },
    }
})

const fallbackImage = '/resources/group_placeholder.png'
const parseLink = (link, cloudfront) => {
    return fallbackImage
    if(!link || !cloudfront) return fallbackImage
    return parseImageUrl(cloudfront)(link) || fallbackImage
}


function TemplateGroupItem(props) {
    const cloudfront = managerTableKeepGlobalData.getCloudfront()

    const {template, classes} = props
    const [t] = useNewUITranslation('i18n_admin')
    const keysNavigationProps = {}
    const link = useMemo(() => {
		const imageLink = parseLink(template?.pictureUrl ?? '', cloudfront)
		return imageLink
	}, [template?.pictureUrl, cloudfront])

    return (
        <>
        <div data-intrcm-id="Group_qw6vcf8b" className={classes.container} >
            <img alt="group" className={classes.pic} src={link} />
            <div data-intrcm-id="Group_661zua8f" className={classes.texts}>
                <div data-intrcm-id="Group_m8q6gcj4" className={classes.title}>{t("Creation in progress, based on {{templateName}}", {templateName: template.title})}</div>
                <div data-intrcm-id="Group_ajudtt06" className={classes.description} >{t("You’ll be notified as soon as it’s ready for use")}</div>
            </div>
            <div data-intrcm-id="Group_ms2a9119" {...keysNavigationProps} className={classes.suggest} />
        </div>
        <Divider className={classes.divider} />
        </>
    )
}

export default compose(
    withStyles(styles, {withTheme: true})
)(TemplateGroupItem)

